import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../../utils/BodyWrap";
import ContentDiv from "../../utils/ContentDiv";
import Loader from "../../utils/Loader";
import SectionBanner from "../../utils/SectionBanner";
import VideosList from "./VideosList";

// State
import { getTranslations } from "../../../store/actions/translations";
import { getVideoSurveys } from "../../../store/actions/trainingVideos";

class TrainingVideos extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["training_videos", "training_video_preview_item"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		const resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	componentWillMount() {
		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			TrainingVideos.initialAction(null, this.props);
		}

		// User has to be logged in to get the surveys
		if (!this.props.videoSurveys) {
			this.props.getVideoSurveys();
		}
	}

	render() {
		const { translationsLoading, translations } = this.props;

		// ===================================
		//	HELMET STUFF
		// ===================================
		let helmet = null;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[this.props.translationKey]) {
			if (title !== "") title += " | ";
			title += translations.pages[this.props.translationKey].title;
		}

		// helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 		<meta property="og:title" content={title} />
		// 		<meta property="og:description" content={title} />
		// 		<meta property="twitter:title" content={title} />
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}
				<main>
					<div className="page-content">
						<div className="section-row">
							{translationsLoading ? (
								<Loader />
							) : !!translations.pages[this.props.translationKey] ? (
								<ContentDiv>
									{translations.pages[this.props.translationKey].content}
								</ContentDiv>
							) : null}
						</div>
						<div className="section-row section-row--block">
							{!translationsLoading && (
								<React.Fragment>
									<SectionBanner
										link={{
											href: `/training/videos/mandatory`,
											title:
												translations.sections.training_videos.mandatory_link
										}}
									>
										{translations.sections.training_videos.mandatory_title}
									</SectionBanner>
									<VideosList videoType="mandatory" />

									<SectionBanner
										link={{
											href: `/training/videos/trainee-mandatory`,
											title:
												translations.sections.training_videos.trainee_link
										}}
									>
										{translations.sections.training_videos.trainee_title}
									</SectionBanner>
									<VideosList videoType="traineeMandatory" />

									<SectionBanner
										classes="grey-banner"
										link={{
											href: `/training/videos/elective`,
											title:
												translations.sections.training_videos.elective_link
										}}
									>
										{translations.sections.training_videos.trainee_title}
									</SectionBanner>
									<VideosList videoType="elective" />
								</React.Fragment>
							)}
						</div>
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		videoSurveys: state.trainingVideos.videoSurveys
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getVideoSurveys }
)(TrainingVideos);



// WEBPACK FOOTER //
// ./src/components/training/videos/TrainingVideos.js